import React, { ReactElement, useCallback, useState } from 'react'
import theme from 'live/services/theme'
import List from 'live/components/ui/List'
import { Column, Direction, OrderState } from '../../types'

import * as S from './styled'
import { CSSObject } from 'styled-components'

interface Props<T = any> {
    filterProps?: {
        term: string
        column: keyof T
    }
    columns: Column<T>[]
    data: T[]
    order?: OrderState
    sort: boolean
    selectedRow?: number
    selectable?: boolean
    removable?: boolean
    onClickRow?: (row: T, rowIndex: number) => void
    onNewRow?: () => void
    onRemoveRow?: (row: any, rowIndex: number) => void
    style?: CSSObject
}

const defaultDirection: Direction = 'asc'

const Table = <T extends any>({
    sort,
    order,
    columns,
    data,
    selectable,
    selectedRow,
    removable,
    filterProps,
    onClickRow,
    // onNewRow,
    // onRemoveRow,
    style
}: Props<T>): ReactElement<Props<T>> => {
    const [orderState, setOrderState] = React.useState(
        order || {
            prop: columns.length ? columns[0]['dataIndex'] : '',
            dir: defaultDirection
        }
    )

    const renderColumn = (column: Column<T>) => {
        const { key, width, renderColumn, title, fixed } = column
        return (
            <S.HeaderItem key={key} width={width} className={fixed ? 'fixed' : undefined}>
                <div>{renderColumn ? renderColumn(column) : title}</div>
            </S.HeaderItem>
        )
    }

    // const removeRow = (row: any, index: number) => {
    //     if (!onRemoveRow) {
    //         return
    //     }
    //     onRemoveRow(row, index)
    // }

    const renderRow = (row: T, rowIndex: number) => {
        return (
            <S.Row
                key={rowIndex}
                className={rowIndex === selectedRow ? 'selected' : onClickRow && selectable ? 'selectable' : undefined}
                onClick={() => {
                    if (onClickRow && selectable) {
                        onClickRow(row, rowIndex)
                    }
                }}
            >
                {/* <S.RowItem key={`${rowIndex}-action`} width={20}>
                    {removable ? (
                        <i
                            className="far fa-trash-alt"
                            onClick={(e: any) => {
                                e.stopPropagation()
                                removeRow(row, rowIndex)
                            }}
                        />
                    ) : null}
                </S.RowItem> */}
                {columns.map(({ dataIndex, renderItem, width, fixed }, cellIndex: number) => {
                    const key = `${rowIndex}-${cellIndex}`
                    const value = row[dataIndex as keyof T]
                    return (
                        <S.RowItem key={key} width={width} className={fixed ? 'fixed' : undefined}>
                            <div>{renderItem ? renderItem(value, row, rowIndex) : value}</div>
                        </S.RowItem>
                    )
                })}
            </S.Row>
        )
    }

    return (
        <S.Container style={style}>
            <List
                sort={sort}
                order={orderState}
                items={
                    filterProps?.term && filterProps?.column
                        ? data.filter(row =>
                            String(row[filterProps.column])
                                .toUpperCase()
                                .includes(filterProps.term.toUpperCase())
                        )
                        : data
                }
                render={(items: T[]) => {
                    return (
                        <>
                            <S.Header className={'list-header'}>
                                {/* <S.HeaderItem key="actions" width={20}>
                                    <S.ItemAction
                                        className="far fa-plus-circle"
                                        onClick={() => onNewRow && onNewRow()}
                                    />
                                </S.HeaderItem> */}
                                {columns.map(column => renderColumn(column))}
                            </S.Header>

                            <S.Body className={'list-body'}>
                                {items.map((item, index) => renderRow(item, index))}
                            </S.Body>
                        </>
                    )
                }}
            />
        </S.Container>
    )
}

export default Table
